import dayjs from 'dayjs';

import 'dayjs/locale/lt';

dayjs.locale('lt');
